import React from "react";
import Navigation from "../components/nav";
import BakeryFooter from "../components/footer";
import Singleproductscomponent from "../components/Orders/Singleproductscomponent";
import Breadcrumbs from "../utils/Breadcrumb";


function Product() {
 


  return (
    <>
      <Navigation />
      <Breadcrumbs />
      <Singleproductscomponent />
      
    </>
  );
}

export default Product;
